/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import classNames from 'classnames'
import { useIntl } from 'react-intl'
import { IContactDto } from '../Contact.model'

interface Props {
  data: IContactDto
  rowSelected?: string
  backgroundClass?: string
  hoverBackgroundClass?: string
  showPrimaryIcon?: boolean
  primaryLabel?: string
  onRowClick?: (id: string) => void
}

export const ContactDashboardListItem: FC<Props> = ({
  data,
  rowSelected,
  backgroundClass = 'bg-light-primary',
  hoverBackgroundClass = 'bg-hover-light-primary',
  showPrimaryIcon = false,
  primaryLabel,
  onRowClick,
}: Props) => {
  const intl = useIntl()
  const backGroundClasses = {}
  backGroundClasses[`d-flex flex-stack py-2 ${backgroundClass}`] = data.id === rowSelected

  const hoverBackGroundClasses = {}
  hoverBackGroundClasses[`d-flex flex-stack py-2 ${hoverBackgroundClass}`] = data.id !== rowSelected

  const buildMainLine = (contact: IContactDto) => {
    if (contact) {
      let description = `${contact.email.trim().toUpperCase()}`
      if (contact.telephone) {
        description = description + ` | ${contact.telephone.trim().toUpperCase()}`
      }
      if (contact.address) {
        description = description + ` | ${contact.address.trim().toUpperCase()}`
      }
      if (contact.countryCode) {
        description =
          description + ` | ${intl.formatMessage({id: `DROPDOWN.COUNTRY.${contact.countryCode}`})}`
      }
      return description
    }
    return ''
  }

  return (
    <div
      className={classNames(backGroundClasses, hoverBackGroundClasses)}
      onClick={() => onRowClick && onRowClick(data.id)}
    >
      <div className='d-flex align-items-center'>
        <div className='symbol symbol-35px symbol-circle mx-2'>
          <span className='symbol-label bg-secondary text-light-secondary fs-6 fw-bolder'>
            {data.displayName.charAt(0).toUpperCase()}
          </span>
        </div>
        <div>
          <div>
            {showPrimaryIcon ? (
              <div className='d-flex flex-row justify-content-start align-items-center'>
                <div className='lh-2 fs-7'>
                  <span className='fw-bolder mb-2'>{data.displayName}</span>
                  <span className='text-gray-900 ms-2 me-2 mb-2'>-</span>
                  <span className='text-primary mb-2'>{data.sequence}</span>
                </div>
                <i
                  title={`${
                    !data.primary
                      ? ''
                      : primaryLabel ?? intl.formatMessage({id: 'UTIL.PRIMARY_CONTACT'})
                  }`}
                  className={`ms-3 fs-7 bi bi-star-fill ${
                    !data.primary ? 'text-gray-300' : 'text-primary'
                  }`}
                />
              </div>
            ) : (
              <div className='lh-2 fs-7'>
                <span className='fw-bolder mb-2'>{data.displayName}</span>
                <span className='text-gray-600 ms-2 me-2 mb-2'>-</span>
                <span className='text-primary mb-2'>{data.sequence}</span>
              </div>
            )}
          </div>
          <div className='text-gray-600 fs-8'>{buildMainLine(data)}</div>
        </div>
      </div>
    </div>
  )
}
